import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '@abb/uikit';
import React from 'react';
import LogoIcon from 'shared-components/icons/LogoIcon';
export const RouteLoading = ()=>/*#__PURE__*/ _jsx(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        h: "100vh",
        w: "100%",
        children: /*#__PURE__*/ _jsx(LogoIcon, {})
    });
